// extracted by mini-css-extract-plugin
export var loadingShimmer = "_s3-2";
export var messageContent = "_s3-0";
export var messagesScroll = "_s3-1";
export var shimmer = "_s3-3";
export var shimmerW100 = "_s3-4";
export var shimmerW70 = "_s3-8";
export var shimmerW80 = "_s3-7";
export var shimmerW85 = "_s3-6";
export var shimmerW90 = "_s3-5";